import { Component, OnInit, OnDestroy, AfterViewInit, EventEmitter, Output, ChangeDetectorRef, HostListener } from "@angular/core";
import { FormOfPaymentIssuerSearchCriteria } from "../form-of-payment-issuer-search.model";
import { Select2Data } from "src/app/shared/ui/forms/inputs/oops-select2";
import { select2AirportOption } from "src/app/modules/order/shared";
import { FormOfPaymentIssuerSearchService } from "../form-of-payment-issuer-search.service";
import { Subscription } from "rxjs";
import { filter } from "rxjs/operators";
import * as _ from 'lodash';
import { Router } from "@angular/router";

@Component({
    selector: 'op-form-of-payment-issuer-search-criteria',
    templateUrl: './form-of-payment-issuer-search-criteria.component.html',
})
export class FormOfPaymentIssuerSearchCriteriaComponent implements OnInit, OnDestroy, AfterViewInit {

    focusing = false
    criteria: FormOfPaymentIssuerSearchCriteria = this.getDefaultCriteria()
    initSearch: boolean
    
    dropdownOption = {
        placeholder: '',
        allowClear: true,
        minimumResultsForSearch: -1,
    }

    statusOptionList: Select2Data[]

    private subscriptions: Subscription[]

    @Output() onSearch = new EventEmitter<FormOfPaymentIssuerSearchCriteria>()
    @Output() onClear = new EventEmitter<never>()

    constructor(private formOfPaymentIssuerSearchService: FormOfPaymentIssuerSearchService,
        private cdr: ChangeDetectorRef,
        private router: Router) {
    }

    ngOnInit(): void {
        this.subscriptions = []
    }
    ngOnDestroy(): void {
        this.subscriptions.forEach(s => s.unsubscribe())
    }
    ngAfterViewInit(): void {
        this.subscriptions.push(
            this.formOfPaymentIssuerSearchService.callSearch$
                .pipe(
                    filter(flg => !!flg && !this.initSearch),
                )
                .subscribe(() => {
                    this.search()
                    this.initSearch = true

                    setTimeout(() => {
                        this.useLastCriteria()
                    }, 1000)
                })
        )

        this.subscriptions.push(
            this.formOfPaymentIssuerSearchService.statusReferenceModels$.subscribe(response => {
                this.statusOptionList = response.map(r => new Select2Data(r.statusCode, r.displayName))
                this.cdr.markForCheck()
            })
        )
    }

    private useLastCriteria() {
        this.subscriptions.push(
            this.formOfPaymentIssuerSearchService.criteria$
                .pipe(filter(f => !!f))
                .subscribe(dataMap => {
                    const currentTabId = this.router.url.split('/')[3]
                    const lastCriteria = dataMap.get(currentTabId);
                    if (!_.isEqual(lastCriteria, this.criteria)) {
                        if (lastCriteria) {
                            this.criteria = lastCriteria
                            this.search()
                        }
                    }
                })
        );
    }

    search(): void {
        this.onSearch.emit(this.criteria)
    }
    clear(): void {
        this.criteria = this.getDefaultCriteria()
        this.onClear.emit()
    }

    @HostListener("window:keydown", ["$event"])
    public keyDown(event) {
        const enterKeyCode = 13;
        switch (event.keyCode) {
            case enterKeyCode:
                this.search()
                break
        }
    }
    dataChange(value: any, controlName: string): void {
        this.criteria[controlName] = value
    }


    private getDefaultCriteria(): FormOfPaymentIssuerSearchCriteria {
        return {
            statusCode: 'A'
        };
    }

}
